import React from "react"
import { Block } from "baseui/block"
import { Button, SHAPE } from "baseui/button"
import { H4, Paragraph4 } from "baseui/typography"
import { ArrowRight } from "baseui/icon"
import { Link, useIntl } from "gatsby-plugin-intl"

const gap = 6
const gapTablet = 6
const gapMobile = 6

const fullGap = ["0px", `${gapTablet}px`, `${gap}px`, `${gap}px`]

const containerGap = [
  `0px`,
  `${gapTablet / 2}px`,
  `${gap / 2}px`,
  `${gap / 2}px`,
]

const PackageCard = ({ packageData }: any) => {
  const intl = useIntl()
  return (
    <Block
      to={`/package/${packageData.name}`}
      as={Link}
      className={"package-card"}
      display={"block"}
      backgroundColor={"#1C1C1C"}
      width={"100%"}
      height={"auto"}
      position={"relative"}
      overrides={{
        Block: {
          style: ({ $theme }) => ({
            textDecoration: "none",
            borderRadius: "8px",
            boxShadow: $theme.lighting.shadow400,
          }),
        },
      }}
      overflow={"hidden"}
    >
      <div className={"banner-image"}>
        <Block as={"img"} src={packageData.bannerImg} />
      </div>
      <Block height={"auto"}>
        <Block
          height={"36px"}
          paddingTop={"15px"}
          paddingBottom={"20px"}
          paddingLeft={["10px", "10px", "19px", "19px"]}
          paddingRight={["10px", "10px", "19px", "19px"]}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <H4
            color={"white"}
            marginTop={"0px"}
            marginBottom={"0px"}
            overrides={{
              Block: {
                style: ({ $theme }) => ({
                  whiteSpace: "normal",
                  overflow: "hidden",
                  wordBreak: "break-word",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical",
                  [$theme.mediaQuery.medium]: {
                    WebkitLineClamp: 1,
                  },
                }),
              },
            }}
          >
            {packageData.name}
          </H4>
          <Block
            as={"img"}
            src={packageData.image}
            height={"auto"}
            width={"30%"}
          />
        </Block>
        <Block
          paddingBottom={"20px"}
          marginLeft={["10px", "10px", "19px", "19px"]}
          marginRight={["10px", "10px", "19px", "19px"]}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          $style={{ borderBottom: "1px solid #494949" }}
        >
          <Paragraph4
            overrides={{
              Block: {
                style: ({ $theme }) => ({
                  whiteSpace: "normal",
                  overflow: "hidden",
                  wordBreak: "break-word",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  fontFamily: "True Text A",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  letterSpacing: ".3px",
                  fontSize: "1.25em",
                  lineHeight: "1.28em",
                  minHeight: "2.56em",
                  maxHeight: "auto",
                  [$theme.mediaQuery.medium]: {
                    fontSize: "1.25em",
                    lineHeight: "1.28em",
                    minHeight: "2.56em",
                    maxHeight: "auto",
                  },
                  [$theme.mediaQuery.large]: {
                    fontSize: "1.25em",
                    lineHeight: "1.28em",
                    minHeight: "2.56em",
                    maxHeight: "2.56em",
                  },
                }),
              },
            }}
            marginTop={"0px"}
            marginBottom={"0px"}
            color={"#E0E0E0"}
          >
            {packageData.description}
          </Paragraph4>
        </Block>
      </Block>
      <Block
        marginTop={"16px"}
        marginBottom={"16px"}
        marginLeft={["10px", "10px", "19px", "19px"]}
        marginRight={["10px", "10px", "19px", "19px"]}
        display={"flex"}
        justifyContent={"flex-end"}
      >
        <Button
          $style={{ width: "150px", fontSize: ".8em" }}
          shape={SHAPE.pill}
          endEnhancer={() => <ArrowRight className={"arrow"} size={"1.5em"} />}
          overrides={{
            EndEnhancer: {
              style: {
                marginLeft: "0px",
              },
            },
          }}
        >
          {intl.formatMessage({ id: "ViewDetail" })}
        </Button>
      </Block>
    </Block>
  )
}

type PackageCollectionProps = {
  packages: any[]
  tone: string
}

const PackageCollection = ({ packages }: PackageCollectionProps) => {
  return (
    <Block marginTop={"40px"}>
      <Block
        display={"flex"}
        justifyContent={"center"}
        flexDirection={"row"}
        flexWrap={true}
        width={"100%"}
        margin={"auto"}
      >
        {packages.map(pack => (
          <Block
            key={pack.id}
            height={"100%"}
            width={["100%", "50%", "33%", "33%"]}
            marginBottom={[`${gapMobile}px`, "0px", "0px", "0px"]}
          >
            <Block
              paddingLeft={containerGap}
              paddingRight={containerGap}
              paddingBottom={fullGap}
            >
              <PackageCard packageData={pack} />
            </Block>
          </Block>
        ))}
      </Block>
    </Block>
  )
}

export default PackageCollection
